import React from "react";
import clicksDarkLogo from "~/images/clicks-dark-new.svg";
const AuthHeader = () => {
  return (
    <div class="">
      <div class="border-b border-[#e0e6e9] min-h-[80px] w-full flex items-center justify-center">
        <div class="w-full max-w-[85%] sm:max-w-[80%] lg:max-w-[1100px]">
          <img src={clicksDarkLogo} className="w-[96px] h-[22px]" />
        </div>
      </div>
    </div>
  );
};
export default AuthHeader;
